import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { Invitation } from '../types/invitation';

export type GetFirmInvitationsResponse = {
    invitations: Invitation[];
    totalRows: number;
};

type UseFirmInvitationsConfig = {
    page: number;
    limit: number;
    search?: string;
    sort?: string;
    filter?: string;
    searchFilters?: string;
};

async function getFirmInvitations({
    page,
    limit,
    search,
    sort,
    filter,
    searchFilters,
}: UseFirmInvitationsConfig): Promise<GetFirmInvitationsResponse> {
    const query = `${filter}&page=${page}&${sort}&search=${search || ''}&limit=${limit}&${searchFilters}`;
    const { data } = await api.get(`/invitations?${query}`);

    return data;
}

export function useFirmInvitations({
    page,
    limit,
    search,
    sort,
    filter,
    searchFilters,
}: UseFirmInvitationsConfig): UseQueryResult<GetFirmInvitationsResponse, unknown> {
    return useQuery(
        ['invitations', page, limit, search, sort, filter, searchFilters],
        () => getFirmInvitations({ page, limit, search, sort, filter, searchFilters }),
        {
            keepPreviousData: true,
        }
    );
}
